import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { merge, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { DataService } from "src/app/services/Data.service";
import { SlottedPipeService } from "src/app/services/slotted-pipe/slotted-pipe.service";
import {
  AbstractControlWarning
} from "src/app/shared/helpers/AbstractControlWarning";
import { SlottedModalComponent } from "../../../shared/slotted-modal/slotted-modal.component";
import { DCSlottedPipesRequest } from "../../models/slotted-pipe";
import { SlottedService } from "../../services/slotted.service";
import { Groupings } from "../../../shared/enums/groupings.enum";
import { Patterns } from "../../../shared/enums/patterns.enum";


@Component({
  selector: "app-slotted-pipes",
  templateUrl: "./slotted-pipes.component.html",
  styleUrls: ["./slotted-pipes.component.css"],
})
export class SlottedPipePipesComponent implements OnInit, OnDestroy {
  @Input() fgSlottedPipe: UntypedFormGroup;

  @ViewChild(SlottedModalComponent)
  slottedModalComponent: SlottedModalComponent;

  showDataCheck: boolean = false;
  refreshDataCheckData$: Subscription;

  canEditPipes: boolean = false;
  wtByOdWarning: boolean = false;

  constructor(
    private slottedService: SlottedService,
    private slottedPipeService: SlottedPipeService,
    public dataService: DataService
  ) {}

  ngOnInit(): void {
    this.dataService.currentRolSource.pipe().subscribe((role) => {
      this.canEditPipes = role.some(x => x == "ADMIN") || role.some(x => x == "SUPER_USER");
    });

    this.refreshDataCheckData$ =
      this.slottedService.refreshDataCheckData$.subscribe((refreshData) => {
        if (refreshData.section == "PIPES") this.dataCheck();
      });

    merge(
      this.fgSlottedPipe.get("fgPipes").valueChanges,
      this.fgSlottedPipe.get("fgType").valueChanges
    ).subscribe(() => {
      if (
        this.fgSlottedPipe.get("fgType").valid &&
        this.fgSlottedPipe.get("fgPipes").valid
      ) {
        this.showDataCheck = true;
      } else {
        this.showDataCheck = false;
      }
    });

    merge(
      this.fgSlottedPipe.get("fgPipes").get("outsideDiameter").valueChanges,
      this.fgSlottedPipe.get("fgPipes").get("wallThickness").valueChanges
    ).subscribe(() => {
      let od = Number(
        String(
          this.fgSlottedPipe.get("fgPipes").get("outsideDiameter").value
        ).replace(",", ".")
      );
      let wt = Number(
        String(
          this.fgSlottedPipe.get("fgPipes").get("wallThickness").value
        ).replace(",", ".")
      );

      if (
        this.fgSlottedPipe.get("fgPipes").get("outsideDiameter").value != "" &&
        this.fgSlottedPipe.get("fgPipes").get("wallThickness").value != "" &&
        od &&
        wt &&
        wt >= od / 2
      ) {
        if (this.canEditPipes) this.wtByOdWarning = true;
        else
          setTimeout(() => {
            this.fgSlottedPipe.get("fgPipes").setErrors({ wtByOd: true });
          }, 1);
      } else {
        if (this.canEditPipes) this.wtByOdWarning = false;
        else this.fgSlottedPipe.get("fgPipes").setErrors(null);
      }
    });
  }
  
  dataCheck() {
    let dcSlottedPipesRequest: DCSlottedPipesRequest = {
      iConnection: this.fgSlottedPipe.get("fgPipes").get("connection").value,
      iGrade: this.fgSlottedPipe.get("fgPipes").get("grade").value,
      iGradeStrength: this.fgSlottedPipe.get("fgPipes").get("gradeStrength")
        .value,
      iNominalWeight: this.fgSlottedPipe.get("fgPipes").get("nominalWeight")
        .value,
      iOutsideDiameter: this.fgSlottedPipe.get("fgPipes").get("outsideDiameter")
        .value,
      iPipeBodyCollapseRating: this.fgSlottedPipe
        .get("fgPipes")
        .get("pipeBodyCollapseRating").value,
      iRemainingBodyWall: this.fgSlottedPipe
        .get("fgPipes")
        .get("minWallThickness").value,
      iWallThickness: this.fgSlottedPipe.get("fgPipes").get("wallThickness")
        .value,
      rdAligned:
        this.fgSlottedPipe?.get("fgType").get("pattern").value ===
        Patterns.Aligned,
      rdStaggered:
        this.fgSlottedPipe?.get("fgType").get("pattern").value ===
        Patterns.Staggered,
      rdGroupingGangs:
        this.fgSlottedPipe?.get("fgType").get("grouping").value ===
        Groupings.Gangs,
      rdGroupingSingle:
        this.fgSlottedPipe?.get("fgType").get("grouping").value ===
        Groupings.Single,
      rdNo: this.fgSlottedPipe?.get("fgType").get("groovesMachinedWithSaw")
        .value === false,
      rdYes: this.fgSlottedPipe?.get("fgType").get("groovesMachinedWithSaw")
        .value === true,
    };

    this.slottedPipeService
      .dataCheckSlottedPipes(dcSlottedPipesRequest)
      .subscribe((data) => {
        let dataCheckData = [];

        if (data.results.Output.hasError)
          for (let key in data.results.Output.errors) {
            let errorData = {
              type: "ERROR",
              parent: data.results.Output.belongsTo,
              description: data.results.Output.errors[key].description,
              options: data.results.Output.errors[key].options,
            };

            for (let optionKey in data.results.Output.errors[key].options) {
              errorData.options.push(
                data.results.Output.errors[key].options[optionKey]
              );
            }

            dataCheckData.push(errorData);
          }

        if (data.results.Output.hasWarning)
          for (let key in data.results.Output.warnings) {
            let warningData = {
              type: "WARNING",
              parent: data.results.Output.belongsTo,
              description: data.results.Output.warnings[key].description,
              options: [],
            };

            for (let optionKey in data.results.Output.warnings[key].options) {
              warningData.options.push(
                data.results.Output.warnings[key].options[optionKey]
              );
            }

            dataCheckData.push(warningData);
          }

        this.slottedService.setDataCheckData(dataCheckData, "PIPES");
      });
  }

  resetModal() {
    this.slottedModalComponent.preloadFilters(this.fgSlottedPipe.get("fgPipes").value);    
  }

  get gradeWarning() {
    return this.fgSlottedPipe
      .get("fgPipes")
      .get("gradeWarning") as AbstractControlWarning;
  }

  get outsideDiameter() {
    return this.fgSlottedPipe
      .get("fgPipes")
      .get("outsideDiameter") as AbstractControlWarning;
  }

  get wallThickness() {
    return this.fgSlottedPipe
      .get("fgPipes")
      .get("wallThickness") as AbstractControlWarning;
  }

  get nominalWeight() {
    return this.fgSlottedPipe
      .get("fgPipes")
      .get("nominalWeight") as AbstractControlWarning;
  }

  get minWallThickness() {
    return this.fgSlottedPipe
      .get("fgPipes")
      .get("minWallThickness") as AbstractControlWarning;
  }

  ngOnDestroy(): void {
    this.refreshDataCheckData$.unsubscribe();
  }
}
